<template>
  <b-modal
      ref="command-creation-modal"
      hide-footer
      title="Créer une commande"
      size="lg"
  >
    <div class="d-block">
      <b-container fluid>
        <h6 style="text-align:center;">
            Commande <b-badge variant="info">{{reference}}#{{card_number}}</b-badge>  du  client {{form.customer}}
        </h6>
        <br>
        <div>
          <b-row>
            <b-col sm="4">
              <label>Type de commande :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input v-model="form.command_type" disabled></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Domaine :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input v-model="form.domain" disabled></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Fournisseur interne :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="text" v-model="form.internal_supplier" minlength="4" maxlength="4" :state="!isEmpty(form.internal_supplier)" :formatter="formatter" placeholder="AMIT"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Marguerite :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="text" v-model="form.daisy"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Date de commande :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="date" v-model="form.command_date"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Date de rendu :</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="date" v-model="form.delay_ask" ></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="4">
              <label>Charge estimée (jours):</label>
            </b-col>
            <b-col sm="8">
              <b-form-input type="number" step="0.05" min="0" v-model="form.estimated_workload" placeholder="ex : 0,5"></b-form-input>
            </b-col>
          </b-row>
        </div>
        <hr>
        <div style="overflow:auto;">
          <div style="display: flex;justify-content: center;align-items: center;">
            <b-button
              class="mt-5"
              variant="info"
              id="nextBtn"
              :disabled="(this.isEmpty(this.form.internal_supplier))"
              @click="save()"
            >
              Enregistrer
            </b-button>
          </div>
        </div>
        <!-- <div style="text-align:center;margin-top:20px;">
          <span class="step" v-bind:class="[{active:true}]"></span>
        </div> -->
      </b-container>
    </div>
  </b-modal>
</template>

<script>
import server from '../../api/server.vue'

export default {
  name: 'CommandCreationModal',
  data() {
    const now = new Date()
    const today = now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
    return {
      loading: false,
      form:{
        customer: '',
        case_type: '',
        case_line:'',
        contact: '',
        command_type: 'Commande',
        command_date: today,
        domain: 'Etude',
        descriptif: '',
        plant: '',
        details: '',
        internal_customer: '',
        internal_supplier: '',
        daisy: '',
        estimated_workload: 0,
        delay_ask: 0
      },
      reference: '',
      card_number: '',
    }
  },
  watch: {
  },
  computed: {
  },
  methods: {
    formatter(value) {
      return value.toUpperCase()
    },
    isEmpty (value) {
      return _.isEmpty(value)
    },
    hideModal () {
      this.$refs['command-creation-modal'].hide()
    },
    showModal (kanban) {
      this.form.customer = kanban.customer
      this.form.case_type = kanban.case_type.replace(/\s/g, '')
      this.form.case_line =kanban.reference.split('-')[1]
      this.form.contact = kanban.contact
      this.form.descriptif = kanban.descriptif
      this.form.plant = kanban.plant
      this.form.details = kanban.details
      this.form.internal_customer = kanban.internal_customer
      this.reference = kanban.reference
      this.card_number = kanban.card_number
      this.$refs['command-creation-modal'].show()
    },
    save () {
      this.loading = true
      if (this.checkDate ()) {
        server.addKanbanBe(this.form).then(res => {
          this.$toasted.success('Carte kanban crée!')
          this.$emit('saved')
          this.hideModal()
          this.loading = false
          this.cleanForm()
        }).catch((error) => {
          this.$toasted.error(`Mince ! Une erreur <br> ${error}`)
        })
      }
      else {
        this.$toasted.error('Vérifier les champs et la cohérence des dates')
      }
    },
    cleanForm () {
      const now = new Date()
      this.form.customer= ''
      this.form.case_type= ''
      this.form.case_line= ''
      this.form.contact= ''
      this.form.command_type= 'Commande'
      this.form.command_date= now.getFullYear()+'-'+(now.getMonth()+1)+'-'+now.getDate()
      this.form.domain= 'Etude'
      this.form.descriptif= ''
      this.form.details= ''
      this.form.internal_customer= ''
      this.form.internal_supplier= ''
      this.form.daisy= ''
      this.form.estimated_workload= 0
      this.form.delay_ask= 0

    },
    checkDate () {
      if (this.form.command_date && this.form.delay_ask){
        if (this.form.command_date > this.form.delay_ask) {
          return false
        } else {
          return true
        }
      }
      else {
        return false
      }
    },
  },
  mounted: function() {
  },
};
</script>

<style>
input.invalid {
  background-color: #ffdddd;
}

select.invalid {
  background-color: #ffdddd;
}

.step {
  height: 15px;
  width: 15px;
  margin: 0 2px;
  background-color: #bbbbbb;
  border: none;
  border-radius: 50%;
  display: inline-block;
  opacity: 0.5;
}

.step.active {
  opacity: 1;
}

.step.finish {
  background-color: #4CAF50;
}

</style>


// WEBPACK FOOTER //
// src/components/modal/CommandCreationModal.vue